import { useLayoutEffect, useEffect, useCallback } from 'react'
import { useSelector, useDispatch, shallowEqual } from 'react-redux'
import injectSheet from 'react-jss'
import Meta from '@/components/Meta'
import GridItem from '@/components/__new/GridItem'
import useFetchData from '@/hooks/useFetchData'
import actions from '@/actions'
import useScrollStore from '@/store/scroll'
import style from './style'

function Products({
  classes,
  cpt,
  stub,
}) {
  const lenis = useScrollStore((state) => state.lenis)
  const { pageData: page } = useFetchData(stub, 'pages', false, {}, false)

  /*------------------------------
  Redux Connect
  ------------------------------*/
  const { taxonomies } = useSelector((state) => ({
    taxonomies: Object.values(state.page.taxonomies?.[cpt] || {}) || [],
  }), shallowEqual)

  /*------------------------------
  Redux Actions
  ------------------------------*/
  const dispatch = useDispatch()
  const updatePageReady = useCallback((index) => dispatch(actions.loading.setReady(index)), [dispatch])
  const getAllTerms = useCallback((tax, number, param) => dispatch(actions.page.getAllTerms(tax, number, param)), [dispatch])
  const setTranslations = useCallback((p) => dispatch(actions.locale.setTranslations(p)), [dispatch])

  useLayoutEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  useEffect(() => {
    if (Object.keys(page).length > 0) {
      updatePageReady(true)
    }
  }, [page])

  useEffect(() => {
    if (taxonomies.length === 0) getAllTerms(cpt, 10)
    return () => setTranslations(null)
  }, [])

  useEffect(() => {
    if (lenis) lenis.stop()
  }, [lenis])

  useEffect(() => {
    if (page?.wpml_translations?.length > 0) setTranslations(page)
  }, [page.wpml_translations])

  return (
    <>
      {page.yoast_head ? <Meta head_json={page.yoast_head} /> : null}
      <div className={classes.root}>
        <div className={classes.page}>
          <div className={classes.header}>
            <div className={classes.heading}>
              {page?.title?.rendered ? <h1 dangerouslySetInnerHTML={{ __html: page.title.rendered }} /> : null}
              <div className={classes.description} dangerouslySetInnerHTML={{ __html: page?.content?.rendered || '' }} />
            </div>
          </div>
          <div className={classes.grid}>
            {taxonomies.map((taxonomy) => (
              <GridItem
                key={taxonomy.id}
                data={{
                  title: {
                    rendered: taxonomy?.name,
                  },
                  link: taxonomy?.link,
                  featured_image: taxonomy?.acf?.featured_image?.url,
                  featured_image_alt: taxonomy?.acf?.featured_image?.alt,
                  featured_image_title: taxonomy?.acf?.featured_image?.title,
                }}
              />
            ))}
          </div>
        </div>
      </div>
    </>
  )
}

export default injectSheet(style)(Products)
